import React from 'react';

export const AutocompletePreview = ({ component, onClick, isSelected }) => {
  const { commonAttrs, specificAttrs } = component;
  const { placeholder, label } = specificAttrs || {};
  
  const containerStyle = {
    padding: `${commonAttrs?.paddingTop || 16}px ${commonAttrs?.paddingRight || 16}px ${commonAttrs?.paddingBottom || 16}px ${commonAttrs?.paddingLeft || 16}px`,
    margin: `${commonAttrs?.marginTop || 8}px ${commonAttrs?.marginRight || 0}px ${commonAttrs?.marginBottom || 8}px ${commonAttrs?.marginLeft || 0}px`,
    width: commonAttrs?.width === 'auto' ? 'auto' : `${commonAttrs?.width || 100}%`,
    cursor: onClick ? 'pointer' : 'default',
    border: isSelected ? '2px solid #3B82F6' : '2px solid transparent',
    borderRadius: '4px'
  };
  
  return (
    <div style={containerStyle} onClick={onClick}>
      <div>
      {label && <label style={{ display: 'block', marginBottom: '4px', fontSize: '14px', fontWeight: '500' }}>{label}</label>}
      <input
        type="text"
        placeholder={placeholder || 'Search...'}
        style={{
          width: '100%',
          padding: '8px',
          border: '1px solid #D1D5DB',
          borderRadius: '6px',
          fontSize: '14px'
        }}
      />
      </div>
    </div>
  );
};
